import service from "../../services/gestionEmpleados/atributes";

export default {
  namespaced: true,
  state: {
    service: new service(),
    atributes: [],
    edit: [],
    new: [],
    allAtributes: [],
    deleteItem: [],
  },

  mutations: {
    setAtributes(state, data) {
      state.atributes = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setAllAtributes(state, data) {
      state.allAtributes = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
  },
  actions: {
    async getAtributes({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getAtributes();

          commit("setAtributes", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getAllAtributes({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getAllAtributes();

          commit("setAllAtributes", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async edit({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.edit(state.edit).then(() => {
            let item = state.edit;

            commit("setEdit", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async newAtribute({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.new(state.new).then(() => {
            let item = state.new;

            commit("setNew", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async delete({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.delete(state.deleteItem).then(() => {
            const deleteitem = state.deleteItem;

            commit("setDeleteItem", deleteitem);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
